/* import __COLOCATED_TEMPLATE__ from './essential-downgrade-warning-modal.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type EssentialDowngradeWarningModalService from 'embercom/services/essential-downgrade-warning-modal-service';

export interface Signature {
  Args: {
    isOpen: boolean;
    onClose: () => void;
    onContinue: () => void;
  };
}

export default class EssentialDowngradeWarningModal extends Component<Signature> {
  @service declare essentialDowngradeWarningModalService: EssentialDowngradeWarningModalService;

  get liteSeatCount() {
    return this.essentialDowngradeWarningModalService.liteSeatCount;
  }

  get pauseWorkflowsWarningProps() {
    return this.essentialDowngradeWarningModalService.pauseWorkflowsWarningProps;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::EssentialDowngradeWarningModal': typeof EssentialDowngradeWarningModal;
    'react/essential-downgrade-warning-modal': typeof EssentialDowngradeWarningModal;
  }
}
